import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Options", -1)
const _hoisted_2 = { class: "text-left w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-0" }, null, -1)
const _hoisted_7 = { class: "mt-1 text-gray-600" }
const _hoisted_8 = { class: "grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50" }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, { class: "relative text-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_PopoverButton, { class: "inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ChevronDownIcon, {
            class: "h-5 w-5",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "opacity-0 translate-y-1",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-to-class": "opacity-0 translate-y-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PopoverPanel, {
            "let:close": "",
            class: "absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4"
          }, {
            default: _withCtx(({ close }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutions, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.name,
                      class: "group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                          class: "h-6 w-6 text-gray-600 group-hover:text-indigo-600",
                          "aria-hidden": "true"
                        }))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => {close(); _ctx.selectOption(item.action); },
                          class: "font-semibold text-gray-900"
                        }, [
                          _createTextVNode(_toDisplayString(item.name) + " ", 1),
                          _hoisted_6
                        ], 8, _hoisted_5),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(item.description), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.callsToAction, (item) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: item.name,
                      href: item.href,
                      class: "flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100"
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                        class: "h-5 w-5 flex-none text-gray-400",
                        "aria-hidden": "true"
                      })),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 8, _hoisted_9))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}